
// ----------------  EXCEL EXPORT -----------------------

import { ExcelService } from '../ApplicationServices/excel.service';
import { saveAs } from "file-saver";
// import { Router, ActivatedRoute } from '@angular/router';


import { Component, OnInit} from '@angular/core';
import { ProductTile } from "../models/product-tile.model";
import { ActivatedRoute, Router } from "@angular/router";
import { CollectionService } from "../ApplicationServices/CollectionService";
import { ProductDetailsService } from '../ApplicationServices/ProductDetailsService';
import { SliderScrollService } from "../ApplicationServices/SliderScrollService";
import { UserInfoStore } from "../shared/store/userInfo.store";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";

 // ---- modal ----------
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

 // ---- modal ----------

@Component({
  selector: 'app-shop-grid-bulkorcorporateorder',
  templateUrl: './shop-grid-bulkorcorporateorder.component.html',
  styleUrls: ['./shop-grid-bulkorcorporateorder.component.scss']
})
export class ShopGridBulkorcorporateorderComponent implements OnInit {

  ELEMENT_DATA: any;
  dataSource: any;
  closeResult: string;
  alertmsg:string=null;
  showalert:boolean=false;

  
    // ----------------  EXCEL EXPORT  --------------------- 
    xlsdata: any[];
    alertmsg101: string = null;     showalert101: boolean = false;
    excelData
    exportFileName: any;
    TODAYIS :string=null;

   // ----------------  EXCEL EXPORT  --------------------- 


  masterSelected:boolean;
  checklist:any;
  checkedList:any;


  SKU: string;
  Itemspricedetails = [];


      //@Input() Bulk:string="1";
     //messages : string = "BULK";
    //Output () smsevent = new EventEmitter<string>();
   //@Output()
  //SendValue=new EventEmitter<string>();


  // ---- modal ----------

  moveModalReference: any;
  //closeResult: string;

  // ---- modal ----------


  loggedIn = false;

  productTileList: ProductTile[] = [];
  productList: ProductTile[] = [];
  collectionServ: CollectionService = null;
  productListAvailable = false;
  private sub: any;
  currentQuickView:ProductTile;
  showQuickView:boolean=false;
  detailedService: ProductDetailsService;
  total:0;
  range='0'

  
   cartItemsyourorders = [];

  //cartItemsyourorders: any[];

  constructor(

    private route: ActivatedRoute,
    private router: Router,
    private collectionService: CollectionService,
    private detailService: ProductDetailsService,
    private sliderService: SliderScrollService,
    private infoStore: UserInfoStore,
    private itemModifierService: ItemModifierService,
    private modalService: NgbModal,

      // --------------- EXCEL EXPORT ----------------

   private excelService: ExcelService,
   // private router: Router

   // --------------- EXCEL EXPORT ----------------


  ) {


    this.masterSelected = false;
    this.checklist = [];
    this.getCheckedItemList();

    this.collectionServ = collectionService;
    this.detailedService = detailService;

   }






  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function(item:any) {

        return item.isSelected == true;
        
      })
    this.getCheckedItemList();
  }


  getCheckedItemList(){
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if(this.checklist[i].isSelected)
      this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }


   //  parseInt(sessionStorage.getItem("UID")parseInt(sessionStorage.getItem("UID")
  // parseInt(sessionStorage.getItem("UID")


  ngOnInit(): void {

    this.FillOrder();

    if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

      this.infoStore.setCartInfo([]);
      sessionStorage.clear();
      this.infoStore.setInfo({});

     alert("Session Expired , Please Login  !!");
      

     }

  }

  

  loginredirect() {
    this.router.navigateByUrl("login");
  }
  
  FillOrder(){


   if (sessionStorage.getItem("OrderMaster_Id")) {

     this.loggedIn = true;
   
      this.detailService
        .getAllCOLLECTIOBulkData()
        .subscribe((event: any) => {
          if (event.length > 0) {

            // this.cartItemsyourorders = event;
            this.checklist = event;

          } else {

            // this.cartItemsyourorders = [];
            this.checklist = [];


          }
        });
     } 
    else 
    {    
      this.loggedIn = false;
      
     }


  }


  manageRes(data: any) {

    this.productListAvailable = false;

    this.productList = [];
    this.total=data.length
    this.range=`1 - ${data.length}`
    for (let index = 0; index < data.length; index++) {
      let prod = new ProductTile();
      prod=data[index];
      //prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
      //prod.CurrentPrize ="Bulk Order"; //"$35.00";
      prod.HotLabel = data[index].PrimaryTagName;
      //prod.HotLabel = "BULK";
      //prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";
      //prod.OldPrize = "Single Order"; //"$55.00";
      prod.ProductTileImgURL1 = data[index].img1; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductTileImgURL2 = data[index].img2; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductBlockImgURL = data[index].img3; //"../../../assets/styles/images/product/2.jpg";
      prod.ProductName = data[index].ItemName; //"robin parrish";
      prod.ProductURL = "#/single-product";
      //prod.ProductURL = "#/bulkorcorporateorder";
      prod.ItemId = data[index].ItemId;
      prod.SKUCode= data[index].SKUCode;
      prod.ProductDescription =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";

      prod.CollectionName = "BULK";
      this.productList.push(prod);
    }
    this.productListAvailable = true;
  }
  ngOnDestroy() {
    if(this.sub){
      this.sub.unsubscribe();}
  }

  contactusRedirect() {
    this.router.navigateByUrl("contact-us");
  }


  
  openMoveModal4(content) {

   // this.onBulkSelectedView();
    // this.cancelForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
   }
  }
  
  
  detOrder( iddss){

    
   if (sessionStorage.getItem("OrderMaster_Id")) {

    this.loggedIn = true;  
     this.detailService
       .getAllCOLLECTIOBulkBySKUData(iddss)
       .subscribe((event: any) => {
         if (event.length > 0) {

          this.SKU= event[0].SKUCode;
           this.Itemspricedetails = event;
         } else {
           this.SKU= "";
           this.Itemspricedetails = [];
         }
       });
       
    } 
   else 
   {    
     this.loggedIn = false;     
   }

  

  }


     
  shipOrder() {     

   
    var other = [];
    const formData = new FormData();
  
     
    for (let i = 0; i < this.checklist.length ; i++) {
      
    // this.checklist[i].selected.forEach((item)=>{other.push({
  
    // Id: item.Id,  
    // CreatedBy : Number(sessionStorage.getItem("UID")),
  
    // });})

  //  for (let i = 0; i < this.checklist.length ; i++) {
     // if(this.checklist[i].isSelected)
   //   this.checkedList.push(this.checklist[i]);
  //  }

   //  this.cartItemsyourorders[i].selected.forEach((item)=>{other.push({

   //this.checklist[i].forEach((item)=>{other.push({
    //this.checklist[i].selected.forEach((item)=>{other.push({
    //this.checklist[i].Checked.forEach((item)=>{other.push({
    //    this.checklist[i].forEach((item)=>{other.push({

   // SKUCode: item.SKUCode,  
   // CreatedBy : Number(sessionStorage.getItem("UID")),
  
   // });})

   if(this.checklist[i].isSelected)
   {
    
    // this.checkedList.push( this.checklist[i].Id,Number(sessionStorage.getItem("UID")) );

    this.detailedService
    .UploadbulkStatusUpdateData( this.checklist[i].Id,Number(sessionStorage.getItem("UID")) )
    .subscribe((event: any) => {
    console.log(event); 
     
    
    });


    }

   
  
    }


    this.onExcelFileSubmitPS2();

    //this.masterSelected = false;
    //this.checklist = [];
   // this.getCheckedItemList();

  
    // });
  
  //  formData.append("params", JSON.stringify(this.checkedList));
  
    // this.detailedService
    // .UploadbulkStatusUpdateData(formData)
    // .subscribe((event: any) => {
    // console.log(event);
  
    
    // });
  
  
  
  }


  
onBulkSelectedView(){

 
 // this.detailedService.getAllCOLLECTIOBulkSelectiveData(Number(sessionStorage.getItem("UID"))).subscribe((data) => {
    //this.bilService.printReportDayBookStatisticsData(  this.i1, this.i2 ,'EARNING','SUMMARY','CASH').subscribe((data) => {
    // this.PS2= data[0].PaidAmount.toString();
   //  this.cartItemsyourorders=data;
    //  this.xlsdata = this.excelData;
    //  this.exportFileName =  "HNSBULK" ;
    //  this.excelService.exportAsExcelFile(this.xlsdata, this.exportFileName);
 
    //  setTimeout(() => {
    //    this.showalert = false;
    //  }, 4000);

    this.detailService
        .getAllCOLLECTIOBulkSelectiveData(Number(sessionStorage.getItem("UID")))
        .subscribe((event: any) => {
          if (event.length > 0) {

             this.cartItemsyourorders = event;
           // this.checklist = event;

          } else {

             this.cartItemsyourorders = [];
           // this.checklist = [];


          }
        });
 
  // });



}  
  

onExcelFileSubmitPS2(){

  this.TODAYIS = this.convertDate(Date.now());
  this.xlsdata=null;     

  this.alertmsg = "Please  wait for a moment , downloading on progress .... !!";
  this.showalert = true;
  
  this.detailedService.getAllCOLLECTIOBulkSelectiveData(Number(sessionStorage.getItem("UID"))).subscribe((data) => {
   //this.bilService.printReportDayBookStatisticsData(  this.i1, this.i2 ,'EARNING','SUMMARY','CASH').subscribe((data) => {
   // this.PS2= data[0].PaidAmount.toString();
    this.excelData=data;
    this.xlsdata = this.excelData;
    this.exportFileName =  "HNSBULK" ;
    this.excelService.exportAsExcelFile(this.xlsdata, this.exportFileName);

    // setTimeout(() => {
    //   this.showalert = false;
    // }, 4000);

    this.alertmsg = "Please  wait for a moment , downloading on progress .... !!";
    this.showalert = true;


  });



  
  this.detailedService.getAllCOLLECTIOBulkSelectiveDelData(Number(sessionStorage.getItem("UID"))).subscribe((data) => {
    
    // setTimeout(() => {
    //   this.showalert = true;
    // }, 4000);

    this.alertmsg = "Please  wait for a moment .... !!";
    this.showalert = true;    

     this.FillOrder();

     setTimeout(() => {
      this.showalert = false;
    }, 4000);

 
   });



}   


convertDate(inputFormat) {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/");
}






}
